//@ts-check
// @ts-ignore
import User from './user.riot';
import { connect } from '@/common/lib/riot-redux';

const mapStateToProps = (state) => {
  return {
    shopId: state.app.shopId,
    web: state.app.web,
    valid: state.app.valid,
    up: state.app.up
  };
};

export default connect(User, mapStateToProps, null);